import { PageContainer } from 'components/PageContainer';
import { WorldFC } from 'components/World';
import { usePageTracking } from 'hooks/usePageTracking';

const TongQuanPage = (props) => {
  usePageTracking('overview');
  return (
    <PageContainer location={props.location}>
      <WorldFC />
    </PageContainer>
  );
};

export default TongQuanPage;
